import { PayloadAction } from '@reduxjs/toolkit'
import api from '../../agent'
import create from './base'

export interface LiveTipsState {
    value: number;
    tips: any[];
    tips_history: {
        page: number;
        limit: number;
        total: number;
        data: any[];
    };
    tips_history_today: {
        page: number;
        limit: number;
        total: number;
        data: any[];
    };
}

const LiveTipsRedux = create('live_tips', {
    value: 0,
    tips: [],
    tips_history: {
        page: 0,
        limit: 10,
        total: 0,
        data: []
    },
    tips_history_today: {
        page: 0,
        limit: 10,
        total: 0,
        data: []
    }

}, {
    incrementByAmount: (state: LiveTipsState, action: PayloadAction<number>) => {
        state.value += action.payload
    }

}, {
    getLiveTips: async (state: LiveTipsState) => {
        const response = await api.getTipsLive()
        return {
            tips: response.data
        }
    },
    getLiveTipsHistory: async (state: LiveTipsState, params: any = {}) => {
        if (!params.hasOwnProperty('page')) {
            params.page = state.tips_history.page
        }
        if (!params.hasOwnProperty('limit')) {
            params.limit = state.tips_history.limit
        }

        const response = await api.getTipsLiveHistory(false, params.page, params.limit)

        return {
            tips_history: {
                ...state.tips_history,
                data: response.data.data,
                total: response.data.total,
                limit: response.data.limit,
                page: response.data.page
            }
        }
    },
    getLiveTipsHistoryToday: async (state: LiveTipsState, params: any = {}) => {
        if (!params.hasOwnProperty('page')) {
            params.page = state.tips_history_today.page
        }
        if (!params.hasOwnProperty('limit')) {
            params.limit = state.tips_history_today.limit
        }

        const response = await api.getTipsLiveHistory(false, params.page, params.limit)

        return {
            tips_history_today: {
                ...state.tips_history_today,
                data: response.data.data,
                total: response.data.total,
                limit: response.data.limit,
                page: response.data.page
            }
        }
    },
    updateGameStatus: async (state: LiveTipsState, params: any = {}) => {
        await api.updateGameStatus(params.id, params.gameId, params.status)
        return {
            tips: state.tips
        }
    }
})

export const {
    getLiveTips,
    getLiveTipsHistory,
    getLiveTipsHistoryToday,
    updateGameStatus

} = LiveTipsRedux.actions

export default LiveTipsRedux.reducer
